import { css } from "@emotion/react";

const Top = () => {
  return (
    <div
      id="top"
      css={css`
        position: relative;
      `}
    >
      <div
        css={css`
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: -999;
          padding-top: 62px;
          background-color: #000;
          display: flex;
          justify-content: center;
          align-items: center;
          &::before {
            content: "";
            display: block;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
          }

          video {
            width: 100%;
            height: auto;
          }

          @media screen and (max-width: 1024px) {
            video {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        `}
      >
        <video muted autoPlay playsInline loop src="/mov/mov.mp4"></video>
      </div>
    </div>
  );
};

export default Top;
